import { render, staticRenderFns } from "./AddStakeholdersModal.vue?vue&type=template&id=6325fc44"
import script from "./AddStakeholdersModal.vue?vue&type=script&lang=js"
export * from "./AddStakeholdersModal.vue?vue&type=script&lang=js"
import style0 from "./AddStakeholdersModal.vue?vue&type=style&index=0&id=6325fc44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports